import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { DeleteIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorIconDestructive } from '@calendly/ui/theme';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PureComponent, forwardRef } from 'react';
import ImageUploadButton from 'components/core/image_upload_button';
import { LastEdited } from '../last_edited';
import { FormatsHint } from './formats_hint';
const containerIsPhoneCss = "c1sm2vb5";
const containerCss = "cvbfdob";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const hintsWrapperIsAdminIACss = "h1ot380z";
const hintsWrapperIsPhoneCss = "h107w23r";
const hintsWrapperCss = "h1gtmgws";
const HintsWrapper = forwardRef((props, ref) => {
  const {
    isAdminIA,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(hintsWrapperCss, {
    [hintsWrapperIsAdminIACss]: isAdminIA,
    [hintsWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
export class ReplaceControl extends PureComponent {
  static propTypes = {
    onFileSelect: PropTypes.func.isRequired,
    onFileError: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    isAdminIA: PropTypes.bool
  };
  render() {
    return <Container>
        {this.props.isAdminIA && <HintsWrapper isAdminIA>
            <LastEdited />
          </HintsWrapper>}
        <ImageUploadButton decoration="secondary-outline" size="small" onFileError={this.props.onFileError} onFileSelect={this.props.onFileSelect} validate>
          {this.props.isAdminIA ? I18n.t('publisher.admin.branding.org_logo_form.update') : I18n.t('publisher.action.update')}
        </ImageUploadButton>
        <Button aria-label={I18n.t('publisher.action.remove')} decoration="ghost" size="small" onClick={this.props.onRemove}>
          <DeleteIcon color={this.props.isAdminIA ? colorIconDestructive : null} />
          {this.props.isAdminIA ? null : I18n.t('publisher.action.remove')}
        </Button>
        {!this.props.isAdminIA && <HintsWrapper>
            <FormatsHint />
          </HintsWrapper>}
      </Container>;
  }
}

require("./replace_control.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./replace_control.js");